import { ProductListDTO } from '../product/product-list.dto';
import { ProductTestListDTO } from '../product-test/product-test-list.dto';
import { TeamAccessDTO } from '../team/team-access.dto';

export class ProductVersionDTO extends TeamAccessDTO {

    version: string;

    description: string;

    product: ProductListDTO;

    tests: Array<ProductTestListDTO>;

}
